import type { PresentationOptionV2 } from 'paintscout'

/** True when the v2 presentation holds at least one block of `type`, anywhere in pages > sections > blocks. */
export function hasBlockType(presentation: PresentationOptionV2 | null | undefined, type: string): boolean {
  return (presentation?.pages ?? []).some((page) =>
    (page.sections ?? []).some((section) => (section.blocks ?? []).some((block) => block.type === type))
  )
}

/**
 * True when the v2 presentation renders the quote's job photos itself.
 *
 * The `pictures` block is gated out of the v2 catalog and the add-menu (#21821), so only a document
 * converted from v1 (`convert-pictures.ts`) carries one. When it doesn't, the estimate document has
 * to render its own Media section — see `showMediaSection` on `Quote` (#22698).
 */
export function hasPicturesBlock(presentation: PresentationOptionV2 | null | undefined): boolean {
  return hasBlockType(presentation, 'pictures')
}
